import PropTypes from 'prop-types';

export const questionPropTypes = {
  q: PropTypes.object,
  user: PropTypes.object,
  onselect: PropTypes.func.isRequired,
};
